<template>
  <paper-modal-container :is-visible="isVisible" title="개인정보 처리방침" :hide-close-button="false" @close="closeModal">
    <div :class="$style.privacyContent">
      <div :class="$style.section">
        <p>
          링꾹라이브 (live.linkook.it, 이하 "사이트")는 「개인정보 보호법」 등
          관련 법령에 따라 이용자의 개인정보를 보호하고 권익을 보장하기 위해
          다음과 같이 개인정보 처리방침을 수립·공개합니다.
        </p>
      </div>

      <div :class="$style.section">
        <h3>1. 개인정보 수집 항목 및 방법</h3>
        <p><strong>가. 이메일 회원가입</strong></p>
        <ul>
          <li>
            <strong>수집 항목</strong>: 이메일 주소, 비밀번호(암호화 저장),
            닉네임
          </li>
          <li>
            <strong>수집 방법</strong>: 이용자가 회원가입 시 직접 입력하여 제공
          </li>
        </ul>

        <p><strong>나. 소셜 로그인 (카카오)</strong></p>
        <ul>
          <li>
            <strong>수집 항목</strong>: 카카오 회원번호, 이메일 주소, 닉네임,
            프로필 이미지
          </li>
          <li>
            <strong>수집 방법</strong>: 이용자가 카카오 로그인을 통해 회원가입
            및 로그인 시 카카오를 통해 제공받음
          </li>
        </ul>

        <p><strong>다. X(구 트위터) 프로필 연동</strong></p>
        <ul>
          <li><strong>수집 항목</strong>: X 사용자명, 닉네임, 프로필 이미지, url(프로필 링크)</li>
          <li>
            <strong>수집 방법</strong>: 가입된 회원이 프로필 화면에서 선택적으로
            X 계정을 연동할 때 X API를 통해 제공받음
          </li>
          <li>
            <strong>수집 목적</strong>: 프로필 정보 동기화 및 닉네임 업데이트
            (로그인 용도 아님)
          </li>
        </ul>

        <p><strong>라. 자동 수집 정보</strong></p>
        <p>
          사이트 내 접속 및 활동 시 아래 정보가 자동으로 생성되어 수집될 수 있습니다.
        </p>
        <ul>
          <li>
            <strong>수집 항목</strong>: 서비스 이용 기록, 접속 로그, 방문일시,
            기기 정보, 쿠키, IP주소, 부정 이용 기록
          </li>
          <li>
            <strong>수집 방법</strong>: 서비스 이용 과정에서 자동으로 생성 및 수집
          </li>
          <li>
            <strong>수집 목적</strong>: 서비스 개선, 통계 분석, 보안 및 부정 이용 방지
          </li>
        </ul>
      </div>

      <div :class="$style.section">
        <h3>2. 개인정보의 수집 및 이용 목적</h3>
        <ul>
          <li>회원 가입 및 본인 확인 (모든 가입 방식)</li>
          <li>서비스 제공 및 이용자 식별</li>
          <li>계정 관리 및 고객 지원</li>
          <li>서비스 내 활동 식별(닉네임 표시 등)</li>
          <li>중요 안내 및 공지 전달(이메일 활용)</li>
          <li>부정 이용 방지 및 서비스 안전성 확보</li>
          <li>이메일 회원가입 시 로그인 인증 및 비밀번호 재설정</li>
          <li>X 계정 연동을 통한 프로필 정보 동기화 및 사용자 편의성 향상</li>
        </ul>
      </div>

      <div :class="$style.section">
        <h3>3. 개인정보의 보유 및 이용 기간</h3>
        <p>
          개인정보의 수집 및 이용목적이 달성된 후나 회원탈퇴와 같은 개인정보 수집
          제공에 대한 동의 철회 시 해당 정보를 파기하는 등 필요한 조치를 취합니다.
          다만 내부 방침 및 관계법령에 따라 보관할 수 있으며, 구체적인 개인정보의
          보유 및 이용기간은 다음과 같습니다.
        </p>
        <ul>
          <li>
            불법적 사용자에 대한 관련 기관 수사 협조에 따라 개인정보가 최대 1년간
            보관 후 파기됩니다.
          </li>
          <li>
            정리되지 않은 게시글 및 댓글은 장기 보관될 수 있습니다.
          </li>
          <li>
            논란 및 악성 이용자의 서비스 이용 제한과 재발 방지를 위해 회원의
            이메일, 서비스 이용 제한 조치 이력을 5년간 보관합니다.
          </li>
          <li>
            전자상거래 등에서의 소비자 보호에 관한 법률, 통신비밀보호법 등 법령에 의해
            보관해야 하는 정보는 법령이 정한 기간 동안 보관합니다.
          </li>
        </ul>
      </div>

      <div :class="$style.section">
        <h3>4. 개인정보의 제3자 제공</h3>
        <p>
          사이트는 원칙적으로 개인정보를 제3자에게 제공하지 않습니다. 다만,
          법령에 따라 수사기관 등 관계 기관이 요구하는 경우 예외적으로 제공할 수
          있습니다.
        </p>
      </div>

      <div :class="$style.section">
        <h3>5. 개인정보 처리 위탁</h3>
        <p>
          현재 개인정보 처리 업무를 외부 업체에 위탁하고 있지 않습니다. 추후
          위탁이 발생하는 경우, 위탁받는 자와 그 업무 내용을 본 방침에
          공지하겠습니다.
        </p>
      </div>

      <div :class="$style.section">
        <h3>6. 이용자의 권리</h3>
        <p>
          이용자는 언제든지 본인의 개인정보에 대해 열람, 정정, 삭제, 처리정지 및
          동의 철회를 요청할 수 있습니다.
        </p>
      </div>

      <div :class="$style.section">
        <h3>7. 개인정보의 파기 절차 및 방법</h3>
        <ul>
          <li>
            <strong>파기 절차</strong>: 회원 탈퇴 요청 또는 보유기간 만료 시
            개인정보를 지체 없이 삭제
          </li>
          <li>
            <strong>파기 방법</strong>: 전자적 파일은 복구할 수 없도록 영구 삭제
          </li>
          <li>
            <strong>이메일 계정</strong>: 이메일 회원가입 시 생성된 Firebase
            Auth 계정도 함께 삭제
          </li>
          <li>
            <strong>소셜 계정 연동</strong>: 소셜 로그인으로 수집된 정보는 해당
            플랫폼과의 연동을 해제하고 당사 서버에서 삭제
          </li>
        </ul>
      </div>

      <div :class="$style.section">
        <h3>8. 개인정보 보호책임 관리</h3>
        <ul>
          <li>개인정보 보호 및 관리 책임: 링꾹라이브 운영자</li>
          <li>연락처: linkookit@gmail.com</li>
          <li>문의 시 신속하고 성실히 답변 드리겠습니다.</li>
        </ul>
      </div>

      <div :class="$style.section">
        <h3>9. 개인정보 처리방침 변경</h3>
        <p>
          본 방침은 법령 개정, 서비스 변경 등에 따라 수정될 수 있으며, 변경 시
          홈페이지를 통해 공지합니다.
        </p>
        <p>공고일자: 2026년 1월 19일<br />시행일자: 2026년 1월 19일</p>
      </div>

      <div :class="$style.actions">
        <button :class="$style.closeButton" @click="closeModal">닫기</button>
      </div>
    </div>
  </paper-modal-container>
</template>

<script>
import PaperModalContainer from "@/components/modal/PaperModalContainer.vue";

export default {
  name: "PrivacyModal",
  components: {
    PaperModalContainer,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close"],
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style module>
.privacyContent {
  text-align: left;
  max-width: 600px;
  margin: 0 auto;
}

.section {
  margin-bottom: 20px;
}

.section h3 {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  border-bottom: 2px solid #8e7f7f;
  padding-bottom: 5px;
}

.section p {
  color: #555;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
}

.section ul {
  color: #555;
  font-size: 14px;
  line-height: 1.6;
  /* margin-left: 20px; */
  margin-bottom: 10px;
}

.section li {
  margin-bottom: 5px;
}

.section strong {
  color: #333;
  font-weight: 600;
}

.actions {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.closeButton {
  background-color: #6f6f6f;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.closeButton:hover {
  background-color: #7a6b6b;
}

/* ================================================
   반응형 디자인
   - Large: 1025px ~ (기본 스타일)
   - Medium: 481px ~ 1024px
   - Small: ~ 480px
   ================================================ */

/* Medium (481px ~ 1024px) */
@media screen and (max-width: 1024px) {
  .privacyContent {
    max-width: 100%;
    padding: 0 10px;
  }

  .section {
    margin-bottom: 18px;
  }

  .section h3 {
    font-size: 15px;
    margin-bottom: 8px;
    padding-bottom: 4px;
  }

  .section p,
  .section ul {
    font-size: 13px;
    line-height: 1.5;
  }

  .actions {
    margin-top: 25px;
    padding-top: 15px;
  }

  .closeButton {
    padding: 10px 25px;
    font-size: 13px;
  }
}

/* Small (~ 480px) */
@media screen and (max-width: 480px) {
  .privacyContent {
    padding: 0 5px;
  }

  .section {
    margin-bottom: 15px;
  }

  .section h3 {
    font-size: 14px;
    margin-bottom: 6px;
    padding-bottom: 3px;
    border-bottom-width: 1.5px;
  }

  .section p,
  .section ul {
    font-size: 12px;
    line-height: 1.45;
    margin-bottom: 8px;
  }

  .section ul {
    margin-left: -15px;
    padding-left: 20px;
  }

  .section li {
    margin-bottom: 4px;
  }

  .actions {
    margin-top: 20px;
    padding-top: 12px;
  }

  .closeButton {
    padding: 8px 20px;
    font-size: 12px;
    border-radius: 5px;
  }
}
</style>
